import capitalize from './capitalize';

import { CookieClient, CookieValues } from '../types';

export default function setCookies(
  client: CookieClient,
  cookies: CookieValues,
  options: Record<string, string | number> = {}
): void {
  const setCookie = ([key, value]: [string, string | boolean]) => {
    if (value)
      client.set(`CVCurrent${capitalize(key)}`, value.toString(), options);
  };

  Object.entries(cookies).forEach(setCookie);
}
